<template>
  <v-card class="task-details-tabbed shadow-off pa-5" data-testid="task-details-tabbed">
    <!-- Tab navigation -->
    <v-col cols="12" class="pa-0">
      <v-card class="shadow-off pa-0">
        <v-card-text class="pt-0 pa-0 d-flex align-center justify-center">
          <v-tabs
            data-testid="task-details-tabbed__tabs"
            v-model="tabify"
            bg-color="primary"
            class="border-bottom d-flex align-center"
            color=""
            height="34"
            :active-color="'#6b67ce'"
          >
            <v-tab data-testid="task-details-tabbed__tab-task-details" :key="0" class="text-transform-none pa-0 px-4 justify-start">
              <p>Task Details</p>
            </v-tab>
            <v-tab data-testid="task-details-tabbed__tab-reconciliation" :key="1" class="text-transform-none pa-0 px-4 justify-start">
              <p>Reconciliation</p>
            </v-tab>
            <v-tab data-testid="task-details-tabbed__tab-file-attachments" :key="2" class="text-transform-none pa-0 px-4 justify-start">
              <p>File Attachments</p>
            </v-tab>
            <v-tab data-testid="task-details-tabbed__tab-information-request" :key="3" class="text-transform-none pa-0 px-4 justify-start">
              <p>Information Request</p>
            </v-tab>
            <v-tab v-if="showLinkedGlsTab" data-testid="task-details-tabbed__tab-linked-gls" :key="4" class="text-transform-none pa-0 px-4 justify-start">
              <p>Linked GLs</p>
            </v-tab>
            <v-tab data-testid="task-details-tabbed__tab-comments" :key="5" class="text-transform-none pa-0 px-4 justify-start" @click="getConversation(task)">
              <p>Comments</p>
            </v-tab>
            <v-tab data-testid="task-details-tabbed__tab-bot-details" :key="6" class="text-transform-none pa-0 px-4 justify-start">
             <p>{{ $constants.BOT_NAME + ' Details' }}</p>
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text class="pa-1">
          <v-tabs-items v-model="tabify" data-testid="task-details-tabbed__panels">
            <v-tab-item :key="0" data-testid="task-details-tabbed__panel-task-details">
              <TaskEditDetails
                :addeditdata="localTask"
                :addeditdataerror="{}"
                :addeditdialog="true"
                :addeditloading="false"
                @checklist-item-updated="handleChecklistItemUpdated"
                @gl-selection-changed="handleGlSelectionChanged"
                @refresh="refreshData"
                @update:number-of-evidences="handleNumberOfEvidences"
                @linked-gl-tab="changesTableLinkedGL"
              />
            </v-tab-item>
            <v-tab-item :key="1" data-testid="task-details-tabbed__panel-reconciliation">
              <Reconciliation :task="task" />
            </v-tab-item>
            <v-tab-item :key="2" data-testid="task-details-tabbed__panel-file-attachments">
              <FileAttachment :fileNamesList="fileNamesList" :task="task" />
            </v-tab-item>
            <v-tab-item :key="3" data-testid="task-details-tabbed__panel-information-request">
              <InfoRequest :viewtaskdata="viewtaskdata" @approve="handleApprove" @reject="handleReject" :task="task" :inforeqstage="inforeqstage" :metadata="metadata" />
            </v-tab-item>
            <v-tab-item v-if="showLinkedGlsTab" :key="4" data-testid="task-details-tabbed__panel-linked-gls">
              <LinkedGls
                :tblinkdialogitems="localTask.__tbtotals ? localTask.__tbtotals.items : []"
                :selectglsLocal="selectglsLocal"
                :tempGlSelection="tempGlSelection"
                :tbComputed="taskListData.tb || []"
                :isUserEditable="false"
                :addeditdata="localTask"
                :searchcustomfilterLocal="searchcustomfilter"
                :filteredgllist="taskListData.tb || []"
                :selectAllgl="selectAllgl"
                @update:selectglsLocal="selectglsLocal = $event"
                @update:tempGlSelection="tempGlSelection = $event"
                @update:selectgls="localTask.__tblinks = $event"
                :key="localTask._id || ''"
                :userLocation="localTask.location"
                @refresh="$emit('refresh')"
                @checklist-item-updated="handleChecklistItemUpdated"
              />
            </v-tab-item>
            <v-tab-item :key="5" data-testid="task-details-tabbed__panel-comments">
              <Comments :conversationList="conversationList" :task="task" :queryMsg="queryMsg" :showprofile="showprofile" :loading="commentsLoading"  @getConversation="getConversation" />
            </v-tab-item>
            <v-tab-item :key="6" data-testid="task-details-tabbed__panel-bot-details">
              <AutoAgentDetails :viewtaskdata="viewtaskdata" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- Removed duplicate/legacy tab content --> 
  </v-card>
</template>

<script>
// Tab index constants for readability
const TAB_TASK_DETAILS = 0;
const TAB_RECONCILIATION = 1;
import Reconciliation from './Reconciliation.vue';
import FileAttachment from './FileAttachment.vue';
import InfoRequest from './InfoRequest.vue';
import LinkedGls from './LinkedGls.vue';
import Comments from './Comments.vue';
import AutoAgentDetails from './AutoAgentDetails.vue';
import TaskEditDetails from './TaskEditDetails.vue';
export default {
  name: 'TaskDetailsTabbed',
  props: {
    task: {
      type: Object,
      required: true
    },
  },
  components: {
      Reconciliation,
      TaskEditDetails,
      FileAttachment,
      InfoRequest,
      LinkedGls,
      Comments,
      AutoAgentDetails
  },
  data() {
    // Carefully initialize metadata for project context
    let metadata = {};
    if (this.task && this.task.metadata && this.task.metadata._id) {
      metadata = this.task.metadata;
    } else if (this.task && this.task.viewtaskdata && this.task.viewtaskdata.project && this.task.viewtaskdata.project._id) {
      metadata = this.task.viewtaskdata.project;
    }
    return {
      // Start directly on Reconciliation tab if evidence already found to avoid post-mount jump
      tabify: (this.task && this.task.isReconFound) ? TAB_RECONCILIATION : TAB_TASK_DETAILS,
      viewtaskdata: this.task.viewtaskdata || {},
      conversationList: (this.task.viewtaskdata && this.task.viewtaskdata.conversation) ? this.task.viewtaskdata.conversation : [],
      commentsLoading: false,
      fileNamesList: [],
      inforeqstage: 0,
      tblinkdialogitems: [],
      queryMsg: '',
      metadata,
      showprofile: true,
      localTask: { ...this.task },
      tempGlSelection: (this.task && this.task.__tblinks) ? [...this.task.__tblinks] : [],
      selectglsLocal: (this.task && this.task.__tblinks) ? [...this.task.__tblinks] : [],
      searchcustomfilter: '',
      selectAllgl: false,
      baseurl: this.api || "/v2/pbc/",
      numberOfEvidences: 2,
      showLinkedGlsTabChangesORnot: false
    }
  },
  watch: {
    task: {
      handler(newTask) {
        if (newTask && newTask._id) {
          // For same-task refreshes, always preserve GL selection state (__tblinks, __tbtotals)
          // These are client-managed and should not be overridden by store refreshes
          const isSameTask = this.localTask && this.localTask._id === newTask._id;
          // Capture previous GL state — treat undefined as null (not yet set) vs [] (intentionally cleared)
          const hadPrevTbLinks = this.localTask && Array.isArray(this.localTask.__tblinks);
          const prevTbLinks = hadPrevTbLinks ? [...this.localTask.__tblinks] : null;
          const hadPrevTbTotals = this.localTask && this.localTask.__tbtotals !== undefined;
          const prevTbTotals = hadPrevTbTotals ? (this.localTask.__tbtotals ? { ...this.localTask.__tbtotals } : null) : undefined;
          this.localTask = { ...newTask };
          if (isSameTask && hadPrevTbLinks) {
            // Same task: always preserve GL state (including intentional empty array)
            this.localTask.__tblinks = prevTbLinks;
            if (hadPrevTbTotals) {
              this.localTask.__tbtotals = prevTbTotals;
            }
          } else {
            // Different task: only fallback-preserve if new data has no GL state at all
            if (!Array.isArray(this.localTask.__tblinks)) {
              this.localTask.__tblinks = hadPrevTbLinks ? prevTbLinks : [];
            }
            if (!this.localTask.__tbtotals && hadPrevTbTotals && prevTbTotals) {
              this.localTask.__tbtotals = prevTbTotals;
            }
          }
          if (Array.isArray(this.localTask.__tblinks)) {
            this.selectglsLocal = [...this.localTask.__tblinks];
            this.tempGlSelection = [...this.localTask.__tblinks];
          }
        }
      },
      deep: true
    },
     showLinkedGlsTab(newVal, oldVal) {
      if (newVal !== oldVal) {
      this.showLinkedGlsTabChangesORnot = true;
    } else {
      this.showLinkedGlsTabChangesORnot = false;
    }
       
     }
  },
  computed: {
    showLinkedGlsTab() {
      // Only show LinkedGls tab if the task type matches ACCOUNT_RECONCILIATION
      const ACCOUNT_RECONCILIATION = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
      return this.localTask.task_type && String(this.localTask.task_type) === String(ACCOUNT_RECONCILIATION);
    },
    taskListData() {
      return this.$store.getters['tasks/getTaskListData'] || {};
    },
    /**
     * O(1) user lookup map from store (backed by formDataV3).
     */
    userMap() {
      return this.$store.getters['tasks/getUserMap'] || {};
    },
    /**
     * O(1) location lookup map from store (backed by formDataV3).
     */
    locationMap() {
      return this.$store.getters['tasks/getLocationMap'] || {};
    },
    /**
     * Map of TB item ID/glcode → TB object for O(1) GL lookups.
     * Keys by both _id and glcode (stringified) since the GL selection
     * component emits glcode strings as selected values.
     * Prefers paginated tbRecords when available.
     */
    tbMap() {
      const tbRecords = this.$store.getters['tasks/getTbRecords'];
      const tb = (Array.isArray(tbRecords) && tbRecords.length > 0)
        ? tbRecords
        : (this.taskListData.tb || []);
      const map = {};
      for (const item of tb) {
        if (item && item._id) map[item._id] = item;
        if (item && item.glcode != null) map[String(item.glcode)] = item;
      }
      return map;
    },
    // Heuristic: treat reconciliation evidence found if task has reconciliation object / flag / or fileNamesList includes patterns
    isReconFound() {
      try {
        if (!this.localTask) return false;
        // Common backend flags (adjust if exact field differs)
        if (this.localTask.isReconFound) return true;
        // If account reconciliation task type and there are any uploaded files treat as found
        // const ACCOUNT_RECONCILIATION = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
        // if (this.localTask.task_type === ACCOUNT_RECONCILIATION && (this.fileNamesList && this.fileNamesList.length > 0)) return true;
      } catch(e) { /* silent */ }
      return false;
    }
  },
  async mounted() {
    // Fetch file attachment data if task.upload exists
    if (this.task && this.task.upload) {
      try {
        const response = await this.axios.post(`/v2/upload/filenames/${this.task.upload}`);
        if (response.data && response.data.data) {
          this.fileNamesList = response.data.data;
        } else {
          this.fileNamesList = [];
        }
      } catch (err) {
        this.fileNamesList = [];
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }
    } else {
      this.fileNamesList = [];
    }
  },
  methods: {
    changesTableLinkedGL() {
      if(this.showLinkedGlsTabChangesORnot){
         this.tabify = 6;
      } else { 
         this.tabify = 4;
      }
      
    },  
    handleNumberOfEvidences(val) {
      this.numberOfEvidences = val;
      this.$emit('update:number-of-evidences', val);
    },
    async refreshData() {
      // Use fetchTask which already calls getAllTasks internally (no double-call)
      const checklistId = this.task.project || this.task._id;
      if (checklistId) {
        const taskId = this.task._id;
        await this.$store.dispatch('tasks/fetchTask', { checklistId, taskId });
        // After store is updated, update localTask from store
        const updatedTask = this.$store.getters['tasks/getTaskById'](taskId);
        if (updatedTask) {
          // Capture previous GL state — preserve even when intentionally empty
          const hadPrevTbLinks = this.localTask && Array.isArray(this.localTask.__tblinks);
          const prevTbLinks = hadPrevTbLinks ? [...this.localTask.__tblinks] : null;
          const hadPrevTbTotals = this.localTask && this.localTask.__tbtotals !== undefined;
          const prevTbTotals = hadPrevTbTotals ? (this.localTask.__tbtotals ? { ...this.localTask.__tbtotals } : null) : undefined;
          this.localTask = { ...updatedTask };
          // Always preserve GL state for same-task refreshes (including intentional empty array)
          if (hadPrevTbLinks) {
            this.localTask.__tblinks = prevTbLinks;
          } else {
            this.localTask.__tblinks = [];
          }
          if (hadPrevTbTotals) {
            this.localTask.__tbtotals = prevTbTotals;
          }
        }
      }
      this.$emit('refresh');
      // After refresh, if reconciliation evidence found, switch to tab 1
      this.$nextTick(() => {
  if (this.isReconFound) this.tabify = TAB_RECONCILIATION;
      });
    },
    handleGlSelectionChanged(newSelection) {
      // Use tbMap for O(1) lookups instead of tb.find()
      const items = newSelection.map(id => this.tbMap[id] || this.tbMap[String(id)]).filter(Boolean);
      let total = 0;
      for (const gl of items) {
        if (gl && gl.closing_amount != null && gl.closing_amount !== '') {
          const amt = parseFloat(gl.closing_amount);
          if (!isNaN(amt)) total += amt;
        }
      }
      this.localTask = {
        ...this.localTask,
        __tblinks: [...newSelection],
        __tbtotals: {
          ...this.localTask.__tbtotals,
          items,
          total
        }
      };
      this.$forceUpdate();
    },
    // Methods will be implemented based on design requirements
    async getConversation(task) {
      this.commentsLoading = true;
      try {
        const result = await this.$store.dispatch('tasks/getConversation', {
          metadataId: this.taskListData.metadata._id,
          taskId: task._id,
          context: this
        });
        if (result && result.success) {
          this.conversationList = result.data;
        } else if (result && result.error) {
          throw new Error(result.error);
        } else {
          throw new Error('Unknown error');
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      } finally {
        this.commentsLoading = false;
        this.$nextTick(() => {
          const chatContainer = this.$refs.chatContainer;
          if (chatContainer) {
            chatContainer.scrollTop = chatContainer?.scrollHeight;
          }
        });
      }
    },
    async handleChecklistItemUpdated({ data }) {
      // Save the GL selection state from the update — this is the source of truth.
      // Use Array.isArray so an intentionally empty [] is captured, not treated as null.
      const hasSavedTbLinks = data && Array.isArray(data.__tblinks);
      const savedTbLinks = hasSavedTbLinks ? [...data.__tblinks] : null;
      const hasSavedTbTotals = data && data.__tbtotals != null;
      const savedTbTotals = hasSavedTbTotals ? { ...data.__tbtotals } : null;

      // Instantly update localTask and emit to parent for instant UI feedback.
      if (hasSavedTbTotals && savedTbTotals.items) {
        // Use __tbtotals directly from emitter (already has resolved items)
        this.localTask = {
          ...this.localTask,
          __tblinks: hasSavedTbLinks ? [...savedTbLinks] : (this.localTask.__tblinks || []),
          __tbtotals: { ...savedTbTotals }
        };
        // Emit instant update to parent for instant UI feedback
        this.$emit('task-instant-updated', { ...this.localTask });
      } else if (hasSavedTbLinks) {
        // Fallback: reconstruct items from tbMap using __tblinks (legacy path)
        const items = savedTbLinks.map(id => this.tbMap[id] || this.tbMap[String(id)]).filter(Boolean);
        let total = 0;
        for (const gl of items) {
          if (gl && gl.closing_amount != null && gl.closing_amount !== '') {
            const amt = parseFloat(gl.closing_amount);
            if (!isNaN(amt)) total += amt;
          }
        }
        this.localTask = {
          ...this.localTask,
          __tblinks: [...savedTbLinks],
          __tbtotals: {
            ...this.localTask.__tbtotals,
            items,
            total
          }
        };
        if (hasSavedTbTotals) {
          savedTbTotals.items = items;
          savedTbTotals.total = total;
        }
        // Emit instant update to parent for instant UI feedback
        this.$emit('task-instant-updated', { ...this.localTask });
      }
      // Force Vue to re-render LinkedGls by updating a dummy key if needed
      this.$forceUpdate();
    },

    async handleApprove(infoRequest) {
      if (!infoRequest || !infoRequest._id) return;
      try {
        await this.axios.post(this.baseurl + "request/changestage/" + infoRequest._id + "/2");
        this.$store.commit("sbSuccess", "Status changed");
        await this.refreshData();
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }
    },
    async handleReject(infoRequest) {
      if (!infoRequest || !infoRequest._id) return;
      try {
        await this.axios.post(this.baseurl + "request/changestage/" + infoRequest._id + "/0");
        this.$store.commit("sbSuccess", "Status changed");
        await this.refreshData();
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }
    }
  }
}
</script>

<style scoped>
.task-details-tabbed {
  border-radius: 4px;
  box-shadow: 0px 2px 16px 0 rgba(44, 62, 80, 0.08) !important;
}

.task-details-tabbed .v-tab--active {
  background-color: var(--color-primary);
  color: #fff;
  border-radius: 6px 6px 0 0;
  transition: background-color 0.3s, color 0.3s, border-radius 0.3s;
}

.tab-content {
    min-height: 300px;
    padding: 16px;
}

.placeholder-content {
    min-height: 150px;
    background-color: #f9f9f9;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
    border: 1px dashed #e0e0e0;
}
</style>
